export type channel = 'email' | 'mobile' | 'all';
export type listType = 'allowlist' | 'blocklist';
export type valueType = 'email' | 'domain' | 'ipAddress' | 'mobile';
export const channelEmail = 'email';
export const channelAll = 'all';
export const recordTypeEmail = 'email';
export const recordTypeIPAddress = 'ipAddress';
export const recordTypeDomain = 'domain';
export const recordTypeMobile = 'mobile';
export const listTypeAllowlist = 'allowlist';
export const listTypeBlocklist = 'blocklist';

export interface IBlocklistAllowlistItem {
  itemKey: string;
  siteId: string;
  updatedAt: string;
  updatedById: string;
  value: string;
  name: string;
  productType: channel;
  listType: listType;
  type: valueType;
  lastEditingComment?: string;
}

export interface IListBlocklistAllowlistResponse {
  data: IBlocklistAllowlistItem[];
}

export interface IListBlocklistAllowlistPostResponse {
  data: IBlocklistAllowlistItem[];
}

export interface ICreateBlocklistAllowListRequest {
  name: string;
  productType: channel;
  listType: listType;
  valueType: valueType;
  values: string[];
}

export interface IDeleteBlocklistAllowListRequest {
  productType: channel;
  listType: listType;
  valueType: valueType;
  value: string;
}

export interface isItemValid {
  items: string[];
  valid: boolean;
}
